import React, { useState, useEffect }  from 'react';
import { Switch, Route, Link, BrowserRouter } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useLocation } from 'react-router-dom';

function Header({user, logout}) {
  const location = useLocation();
  const isActive = (url) => {
    return location.pathname === url;
  }

  const getLink = (url, label) => {
    return <Link className={`nav-link ${isActive(url) ? 'active': ''}`} to={url}>{label}</Link>
  }

  return (
      <Navbar bg="dark" variant="dark" className="nav mb-4">
      <Navbar.Brand href="/">Majesty House Online</Navbar.Brand>
      <Navbar.Toggle />
      {
        user ?
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              {getLink('/', 'Services')}
              {getLink('/Resources', 'Resources')}      
              {getLink('/PrayerRequests', 'Prayer Requests')}  
              {getLink('/Testimonies', 'Testimonies')}  
              {getLink('/Interpretation', 'Interpretation')}  
              {getLink('/Preview', 'Video Preview')}  
            </Nav>        
            <Nav>
              <Navbar.Text>
                {user.nickname}
              </Navbar.Text>
              &nbsp;<a className="nav-link" href="#" onClick={logout}>Logout</a>
            </Nav>
          </Navbar.Collapse>      
        : null
      }    
    </Navbar>
  )
}
export default Header;
